<template>
  <div class="page">
    <div class="logo">
      <img src="@/assets/img/238.png" alt="" />
    </div>
    <div class="title">流量王卡</div>
    <van-field v-model="iccid" name="mobile" label="号码：" label-width="50px" placeholder="请输入您要激活的卡号"
      :rules="[{ required: true, message: '请输入您要激活的卡号' }]" />
    <van-button class="bu_tn" round block type="info" native-type="submit" @click="onSubmit()">登录</van-button>
    <div class="btn-div">
      <van-button class="btn" round plain type="info" @click="toActiveTv()">激活视频</van-button>
    </div>
    <div class="footer" :style="{ 'margin-top': height + 'px' }">
      <img src="@/assets/img/239.png" alt="" />
    </div>
    <!-- <div class="kefu" @click="toKefu()">
      <img src="@/assets/kefu/customer.png" alt="" />
      <div class="zxkf">在 线 客 服</div>
    </div> -->
  </div>
</template>
<script>
import { Dialog } from "vant";
import { wxRequest } from "@/api/user.js";
export default {
  data() {
    return {
      code: "",
      iccid: "",
      height: null,
      userPhone: localStorage.getItem("userPhone"),
    };
  },
  created() {
    var source = "wx18b33905435d410b";
    localStorage.setItem("appid", source);
    localStorage.setItem("isHeadquarterAppid", false);
    var appid = source || process.env.VUE_APP_APPID;
    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid;
    }
    this.height = document.documentElement.clientHeight - 550;
    var redirectUrl = window.location.href;
    // 如果有缓存手机号，更改微信的回调地址。 跳转firstHome获取code （待定）
    if (this.userPhone && this.userPhone.length === 11) {
    }
    var index = redirectUrl.indexOf("code");
    redirectUrl = encodeURIComponent(redirectUrl);
    if (index < 0) {
      window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wxb4bff16244869bed&redirect_uri=${redirectUrl}&response_type=code&scope=snsapi_userinfo#wechat_redirect`;
    } else {
      var search = window.location.search;
      console.log("search", search);
      var startIndex = search.indexOf("code");
      var endIndex = search.indexOf("&", startIndex);
      var str = search.slice(startIndex, endIndex);
      var code = str.slice(str.indexOf("=") + 1);
      this.code = code;
      if (this.$route.query.iccid) {
        this.iccid = this.$route.query.iccid;
      } else {
        this.iccid = localStorage.getItem("recordLoginText");
      }
      localStorage.setItem("wxCode", code);
      this.$store.commit("setIsHeadquarterAppid", "true");
      localStorage.setItem("isHeadquarterAppid", true);
      // 自动登录到 firstHome 带着code
      if (this.userPhone && this.userPhone.length == 11) {
        localStorage.setItem("isAutoHome", 1); // 1表示自动跳转到 firstHome
        localStorage.setItem("iccid", this.iccid); // 需要注意会不会引起bug  此时iccid是虚拟号
        // this.$router.push({
        //   path: '/newUser/firstHome',
        //   query: {
        //     code: this.code
        //   }
        // })
        // return
      }
    }
    if (this.$route.query.iccid) {
      this.iccid = this.$route.query.iccid;
    } else {
      this.iccid = localStorage.getItem("recordLoginText");
    }
  },
  methods: {
    toActiveTv() {
      window.location.href = "http://active.519liuliang.com/active.mp4";
    },
    toKefu() {
      window.location.href =
        "https://work.weixin.qq.com/kfid/kfc936d6fd76f9e8553?enc_scene=ENCGh9rMoMTyL4LpCZxr4rRS9cEQASjTFHye1UzncGz72YL";
    },
    onSubmit() {
      const recordLoginText = this.iccid;
      const data = {
        requestId: this.iccid,
        code: "1",
        isCode: 1,
      };
      localStorage.setItem("recordLoginText", recordLoginText);
      wxRequest("sim/bind", data, "get").then((res) => {
        if (res.data.code === "200") {
          const record = res.data.data;
          const iccid = record.iccid;
          localStorage.setItem("isShowApp", record.isShowApp);
          localStorage.setItem("isShowAppMenu", record.isShowApp);


          localStorage.setItem("PayImgUrl", record.imgUrl);
          localStorage.setItem("payPrice", record.payPrice);

          localStorage.setItem("isAutoHome", 1); // 1表示自动跳转到 firstHome
          localStorage.setItem("isCode", true);
          localStorage.setItem("mobile", record.mobile);
          localStorage.setItem("userPhone", record.userPhone); // 用户绑定得手机号
          localStorage.setItem("supplierTypeName", record.supplierTypeName);
          localStorage.setItem("wxHeadImg", record.wxHeadImg);
          localStorage.setItem("wxNickName", record.wxNickName);
          localStorage.setItem("recordLoginText", recordLoginText);
          localStorage.setItem("supplierName", record.supplierName);
          localStorage.setItem("intoNo", record.intoNo);
          localStorage.setItem("iccid", record.iccid);
          localStorage.setItem("openId", record.openId);
          localStorage.setItem("virtualNo", record.virtualNo);
          localStorage.setItem("isBindPhone", record.isBindPhone);
          localStorage.setItem("tuiPrice", record.tuiPrice); // 赠送金余额
          localStorage.setItem("firstLogin", 1);
          localStorage.setItem("basePkgGroup", record.basePkgGroup);
          this.$store.state.recordLoginText = recordLoginText;
          this.$store.state.supplierCode = res.data.data.supplierCode;
          this.$store.state.iccid = iccid;
          this.$store.commit("setIccid", iccid);
          localStorage.setItem("newHome", 1);
          this.$store.state.newHome = 1;
          this.$store.state.isBindPhone = record.isBindPhone;
          this.$store.state.intoNo = record.intoNo;
          sessionStorage.setItem("intoNo", record.intoNo);
          // 未实名的电信卡用户（通过cardType字段判断），实名认证时将只需要绑定
          const cardType = record.supplierTypeCode;
          const _data = {
            requestId: iccid,
            code: this.code,
            userPhone: record.userPhone,
          };
          if (
            record.supplierCode === "1574603917105295360" &&
            record.cardState === 11
          ) {
            // 深圳联通做特殊限制
            Dialog.confirm({
              title: "换卡提示",
              message:
                "由于运营商管控，当前卡已暂停激活使用。请点击 确定 将为你更换网速更快的移动卡。感谢你的理解和支持！",
            })
              .then(() => {
                window.location.href =
                  "http://webchat.szxxtx.com/#/user/chgCardQuery";
              })
              .catch(() => { });
          } else {
            this.$router.replace("/newUser/home");

          }
        } else {
          Dialog.alert({ title: "提示", message: res.data.message });
        }
      });
    },
  },
};
</script>

<style lang="less" scoped> .page {
   background: url("../../assets/img/240.png") no-repeat top center;
   background-size: 100%;
   position: relative;
   padding-top: 84px;
   height: calc(100% - 84px);

   .logo {
     width: 234px;
     height: 75px;
     margin: 0 auto 60px auto;

     img {
       height: 100%;
       width: 100%;
     }
   }

   .title {
     color: #0088d6;
     font-size: 34px;
     text-align: center;
     font-family: HarmonyOS_Sans_SC_Black;
     font-weight: bold;
   }

   .van-cell {
     width: 85%;
     margin: 30px auto 10px auto;
     background: #f6f6f6;
     height: 52px;
     border-radius: 26px;
     align-items: center;
   }

   ::v-deep .van-cell__title {
     color: #4c4c4c;
     font-size: 14px;
   }

   .bu_tn {
     width: 85%;
     height: 52px;
     margin: auto;
     font-size: 14px;
   }

   .btn-div {
     display: flex;
     justify-items: center;
   }

   .btn {
     width: 50%;
     margin: auto;
     font-size: 14px;
     margin-top: 30px;
   }

   .kefu {
     position: fixed;
     right: 5px;
     top: 60%;
     background: #e6f5f5;
     height: 130px;
     width: 40px;
     border-radius: 20px;
     text-align: center;

     img {
       width: 30px;
       height: 30px;
       margin-top: 10px;
     }

     .zxkf {
       font-size: 14px;
       color: #0088d6;
       word-wrap: break-word;
       writing-mode: tb-rl;
       margin: auto;
       margin-top: 10px;
     }
   }

   .footer {
     width: 170px;
     height: 32px;
     margin: auto;

     img {
       width: 100%;
     }
   }
 }
</style>
